<div class="px-2">
    @if (pages().length) {
        <p-accordion (onOpen)="onPanelOpen($event.index)">
            @for (page of pages(); track page.id) {
                <p-accordion-panel
                    [value]="page.id"
                    [style.border-left]="page.color ? '4px solid ' + page.color : null"
                >
                    <p-accordion-header>
                        <div class="flex justify-content-between align-items-center w-full gap">
                            <span 
                                [class.font-bold]="!page.lastView"
                                [class.font-medium]="page.lastView"
                            >{{ page.name }}</span>
                            <span
                                class="font-size-small mr-3"
                                [class.text-warning]="isOutdated(page)"
                                [pTooltip]="lastChangeTooltip(page)"
                                tooltipPosition="left"
                            >
                                ({{ 'system.settings.guide.fields.lastChangeAt' | translate }}
                                {{ page.lastChangeAt | date: 'd.M.y' }})
                            </span>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div [innerHTML]="page.content | guideHtml"></div>
                    </p-accordion-content>
                </p-accordion-panel>
            }
        </p-accordion>
    } @else {
        <div>{{ 'layout.guide.placeholder' | translate }}</div>
    }
</div>

<div #dialogFooter> </div>
